import script from "./HpComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HpComponent.vue?vue&type=script&setup=true&lang=js"

import "./HpComponent.vue?vue&type=style&index=0&id=1edb6636&scoped=true&lang=scss"
import "./HpComponent.vue?vue&type=style&index=1&id=1edb6636&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1edb6636"]])

export default __exports__